export const configurationHelper = {
  get: (key: string) => {
    let config = (window as any).configuration;

    if (!config) {
      throw new Error("configuration not loaded");
    }

    return config[key];
  },
  isDevelopment: () => {
    let config = (window as any).configuration;

    if (!config) {
      throw new Error("configuration not loaded");
    }

    return config["Environment"] === "DEV";
  },
  isTesting: () => {
    let config = (window as any).configuration;

    if (!config) {
      throw new Error("configuration not loaded");
    }

    return config["Environment"] === "TEST";
  },
  isStaging: () => {
    let config = (window as any).configuration;

    if (!config) {
      throw new Error("configuration not loaded");
    }

    return config["Environment"] === "STAGING";
  },
  isProduction: () => {
    let config = (window as any).configuration;

    if (!config) {
      throw new Error("configuration not loaded");
    }

    return config["Environment"] === "PROD";
  },
};
